// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { getBytes, hexlify } from 'ethers';

/**
 * Simple DER conversion for Ethereum signatures
 */
export const convertToDER = (signature: string): string => {
  if (!signature || signature.trim() === '') {
    return '';
  }
  try {
    const signatureBytes = getBytes(signature);

    const rBytes = signatureBytes.slice(0, 32);
    const sBytes = signatureBytes.slice(32, 64);

    const r = hexlify(rBytes).slice(2);
    const s = hexlify(sBytes).slice(2);

    const rDer = encodeInteger(r);
    const sDer = encodeInteger(s);

    const content = rDer + sDer;
    const length = (content.length / 2).toString(16).padStart(2, '0');

    return '30' + length + content;
  } catch (error) {
    return '';
  }
};

const encodeInteger = (hex: string): string => {
  let trimmed = hex.replace(/^0+/, '') || '0';
  if (trimmed.length % 2 !== 0) {
    trimmed = '0' + trimmed;
  }
  const needsPadding = parseInt(trimmed[0], 16) >= 8;
  const value = needsPadding ? '00' + trimmed : trimmed;
  const length = (value.length / 2).toString(16).padStart(2, '0');
  return '02' + length + value;
};
